/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol extends models.ServiceAccountCredentialsBaseForGcpOauthProtocol {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol>): ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol(), model);
        ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol>): ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.newInstance(<ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcpOauthProtocol.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
